<mn-mines-panel />

@if (aVi()) {
  <mn-amount
    class="amount"
    [min]="minA"
    [amount]="am()"
    [prefix]="prefix"
    [precision]="precision"
    [name]="'bet.amount' | mnTranslate"
    (amountChange)="onAmountChange($event)"
    (amountClicked)="onAmountClick($event)">
    <mn-button size="small" left aEvent="bet_preset_min" (clicked)="onAmountChange(minA, true)">
      <span class="c-20 t-xs u-c">{{ "btn.min" | mnTranslate }}</span>
    </mn-button>
    <mn-button size="small" right aEvent="bet_preset_max" (clicked)="onAmountChange(maxA, true)">
      <span class="c-20 t-xs u-c">{{ "btn.max" | mnTranslate }}</span>
    </mn-button>
  </mn-amount>
}

@if (st(); as state) {
  <div class="actions">
    @switch (state) {
      @case (B_S.S) {
        <mn-button class="f-w" aEvent="btn_start_game" size="large" type="success" radius="r-24" [disabled]="bDi()" (clicked)="onStart()">
          <b class="c-10 d-xs t-sh">{{ "btn.start-game" | mnTranslate }}</b>
          <mn-svg class="i-10 replay" name="replay" />
        </mn-button>
      }
      @case (B_S.P_CA) {
        <mn-button class="f-w" aEvent="btn_autopick" size="large" type="orange" radius="r-24" [disabled]="bDi()" (clicked)="onAutopick()">
          <mn-svg class="i-10" name="double-chance" />
          <b class="c-10 t-xl t-sh">{{ "btn.autopick" | mnTranslate }}</b>
        </mn-button>
        <mn-button class="f-w" aEvent="btn_cancel" type="gray" radius="r-24" [disabled]="bDi()" (clicked)="onCancel()">
          <b class="c-10 t-xl t-sh">{{ "btn.cancel" | mnTranslate }}</b>
        </mn-button>
      }
      @case (B_S.P_CO) {
        <!--todo shared?-->
        <mn-button class="f-w" aEvent="btn_autopick" size="large" type="orange" radius="r-24" [disabled]="bDi()" (clicked)="onAutopick()">
          <mn-svg class="i-10" name="double-chance" />
          <b class="c-10 t-xl t-sh">{{ "btn.autopick" | mnTranslate }}</b>
        </mn-button>
        <mn-button class="f-w" aEvent="btn_cash_out" type="cyan" radius="r-24" [disabled]="bDi()" (clicked)="onCashOut()">
          <div class="f-c g-4">
            <b class="c-10 t-xl t-sh">{{ "btn.cash-out" | mnTranslate }}</b>
            <strong class="c-10 t-sm t-sh">{{ totalWin() }}</strong>
          </div>
        </mn-button>
      }
    }
  </div>
}
